export default "__VITE_ASSET__CuaEk1Ru__"